import React from "react";
import ToggleButton from "./ToggleButton";

const ToggleWithTitle = ({
  title,
  ControllerProps,
  currentSheet,
  parentKey,
  dispatchItemToredux,
  toggleValue,
  setToggleValue,
  defaultValue,
  reduxKey,
  isParent,
}) => {
  console.log(title);
  console.log(isParent);
  return (
    <div
      className={`flex items-center justify-between w-full  ${
        isParent ? "border-none" : "border-b"
      }`}
    >
      <label className={`font-light text-sm`}>{title}</label>
      <ToggleButton
        defaultValue={defaultValue}
        dispatchItemToredux={dispatchItemToredux}
        setToggleValue={setToggleValue}
        reduxKey={reduxKey}
      />
    </div>
  );
};

export { ToggleWithTitle };
